const targetElement = document.querySelector(".product");
const stickyATC = document.querySelector(".sticky-atc__wrapper");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        stickyATC.style.display = "none";
      } else {
        stickyATC.style.display = "block";
      }
    });
  },
  { threshold: 0 }
);

observer.observe(targetElement);

document.querySelector(".select-button").addEventListener("click", function () {
  this.classList.toggle("active");
  const options = this.nextElementSibling;
  options.style.display = options.style.display === "block" ? "none" : "block";
});

document.querySelectorAll(".option").forEach((option) => {
  option.addEventListener("click", function () {
    const buttonText = `Pack : ${this.textContent}`;
    const selectedVariant = this.dataset.optionvariantid;
    const selectedButton = document.querySelector(".select-button");
    selectedButton.textContent = buttonText;
    selectedButton.dataset.variantid = selectedVariant;
    // console.log(selectedButton.dataset.variantid);

    document.querySelector(".options").style.display = "none";
    document.querySelector(".select-button").classList.remove("active");
  });
});

document.addEventListener("click", function (e) {
  const select = document.querySelector(".custom-select");
  if (!select.contains(e.target)) {
    document.querySelector(".options").style.display = "none";
    document.querySelector(".select-button").classList.remove("active");
  }
});

const bundleBoxes = document.querySelectorAll(".bundle-box");
bundleBoxes.forEach((box) => {
  box.addEventListener("click", () => {
    bundleBoxes.forEach((bBox) => bBox.classList.remove("active"));
    box.classList.add("active");
  });
});
